import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { UserRole } from "../api/generated.schemas";

interface RoleGateProps {
  children: React.ReactNode;
  requiredRoles: UserRole | UserRole[];
  fallback?: React.ReactNode;
}

export const RoleGate: React.FC<RoleGateProps> = ({ children, requiredRoles, fallback = null }) => {
  const { hasRole } = useAuth();

  if (!hasRole(requiredRoles)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
